import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { marked } from 'marked';

@Pipe({
  name: 'markdown',
  standalone: true,
  pure: false,
})
export class MarkdownPipe implements PipeTransform {
  transform(markdown: string): SafeHtml {
    if (!markdown) return '';
    const html = marked(markdown, { breaks: true });
    return html.toString();
  }
}
